import { useContext } from "react";
import { CameraContext } from "../providers";

const useCameras = () => {
  const cameraContext = useContext(CameraContext);

  if (!cameraContext) {
    throw new Error("useCamera must be used within an CameraProvider");
  }
  return cameraContext;
};

export default useCameras;
